var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.number)?_c('span',{staticClass:"caption"},[_vm._v("Showing "+_vm._s(_vm.number)+" result.")]):_c('span',{staticClass:"caption"},[_vm._v("No result.")])])}
var staticRenderFns = []

export { render, staticRenderFns }